/**
 * Fragment de routes du paquet v8b-p03-charte-ecrans (vague V8b, règle R2 du découpage V4–V11 : un fragment par
 * paquet). Composants chargés à la demande (règle de chargement du registre).
 *  - remplacements du socle (`couvre: route:` du YAML) : `/org/charte` → organisation-charte, `/org/charte/:id` →
 *    organisation-charte-version ;
 *  - routes neuves : l'éditeur (`/org/charte/composer`, `?source=<id>` pour une reprise), la fiche d'une surcharge
 *    (`/org/charte/surcharges/:surchargeId`), le changement de régime (`/org/charte/:id/regime`) et les deux dialogues de
 *    composant ouverts depuis le lancement d'un projet (`/org/lancements/:projetId/composants/…`).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationCharte = lazy(() => import('../ecrans/v8b/charte/OrganisationCharte'))
const OrganisationCharteVersion = lazy(() => import('../ecrans/v8b/charte/OrganisationCharteVersion'))
const OrganisationCharteEditeur = lazy(() => import('../ecrans/v8b/charte/OrganisationCharteEditeur'))
const OrganisationCharteSurcharge = lazy(() => import('../ecrans/v8b/charte/OrganisationCharteSurcharge'))
const DialogueChangerRegimeCharte = lazy(() => import('../ecrans/v8b/charte/DialogueChangerRegimeCharte'))
const DialogueAjouterComposant = lazy(() => import('../ecrans/v8b/charte/DialogueAjouterComposant'))
const DialogueModifierComposant = lazy(() => import('../ecrans/v8b/charte/DialogueModifierComposant'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v8b-charte',
  routes: [
    { chemin: '/org/charte', element: ecran(OrganisationCharte), remplace: true },
    { chemin: '/org/charte/composer', element: ecran(OrganisationCharteEditeur) },
    { chemin: '/org/charte/surcharges/:surchargeId', element: ecran(OrganisationCharteSurcharge) },
    { chemin: '/org/charte/:id', element: ecran(OrganisationCharteVersion), remplace: true },
    { chemin: '/org/charte/:id/regime', element: ecran(DialogueChangerRegimeCharte) },
    { chemin: '/org/lancements/:projetId/composants/nouveau', element: ecran(DialogueAjouterComposant) },
    { chemin: '/org/lancements/:projetId/composants/:role', element: ecran(DialogueModifierComposant) },
  ],
}
